module.exports = __webpack_public_path__ + "img/mozambique.fd53a918.png";